import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ArrayUtils } from '../utils';

export function validatorAgain(
  pathToOtherControl: string | string[]
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.root?.get(pathToOtherControl)) {
      return null;
    }

    if (ArrayUtils.isArray(pathToOtherControl)) {
      (pathToOtherControl as string[]).forEach((path) => {
        control.root.get(path).updateValueAndValidity({ onlySelf: true });
        control.root.get(path).markAllAsTouched();
      });
    } else {
      control.root
        .get(pathToOtherControl)
        .updateValueAndValidity({ onlySelf: true });
      control.root.get(pathToOtherControl).markAllAsTouched();
    }

    return null;
  };
}
